import React from 'react';

/** Base glass panel. variant: 'default' | 'gold' | 'flat'. Add hover for clickable cards. */
export default function GlassCard({ title, variant = 'default', hover = false, className = '', children, ...rest }) {
  const cls = ['glass-card', variant !== 'default' && `glass-card--${variant}`, hover && 'glass-card--hover', className]
    .filter(Boolean).join(' ');
  return (
    <div className={cls} {...rest}>
      {title && <h3 className="glass-title">{title}</h3>}
      {children}
    </div>
  );
}